"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCachedMessage = exports.convertMinutesToFullHour = void 0;
var messageCache = new Map();
var getCachedMessage = function getCachedMessage(intl, id) {
  if (!id) return "";
  var cachedMessage = messageCache.get(id);
  if (!cachedMessage) {
    cachedMessage = intl.formatMessage({
      id: id
    });
    messageCache.set(id, cachedMessage);
  }
  return cachedMessage || "";
};
exports.getCachedMessage = getCachedMessage;
var convertMinutesToFullHour = function convertMinutesToFullHour() {
  var minutes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var intl = arguments.length > 1 ? arguments[1] : undefined;
  var ignoreMinuteTruncation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var negative = minutes < 0 ? -1 : 1;
  var absoluteMinutes = Math.round(minutes) * negative;
  var fullHours = absoluteMinutes / 60;
  var justHours = Math.trunc(fullHours);
  var justMinutes = absoluteMinutes - justHours * 60;
  var hideMinutes = justMinutes > 0 && justHours > 99 && !ignoreMinuteTruncation;
  if (hideMinutes && justMinutes > 29) {
    justHours++;
  }
  var formatted = negative === -1 ? "-" : "";
  if (justHours > 0 && justMinutes > 0 && !hideMinutes) {
    formatted += justHours + getCachedMessage(intl, "common.hours.short") + " " + justMinutes + getCachedMessage(intl, "common.minutes.short");
  } else if (justMinutes > 0 && !hideMinutes) {
    formatted += justMinutes + getCachedMessage(intl, "common.minutes.short");
  } else {
    formatted += justHours + getCachedMessage(intl, "common.hours.short");
  }
  return formatted;
};
exports.convertMinutesToFullHour = convertMinutesToFullHour;